/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Importing the edit icon

export default function Tr({
  campaign_id,  // Unique ID for the campaign
  art_pack_name,  // ID for the associated art pack
  approved,  // Approval status of the campaign
  campaign_name,  // Name of the campaign
  min_percentage, // Min percentage
  onApprove  // Function to handle editing the campaign
}) {
  return (
    <>
      <tr>
        {/* Displaying campaign details in table cells */}
        <td className="ps-5">{art_pack_name}</td> {/* Displaying approval status */}
        <td className="ps-5">{campaign_name}</td>
        <td className="ps-5 center-text">{`${min_percentage}%`}</td>
        <td className="ps-5 center-text"><input
          type="button"
          value={approved ? "Approved" : "Approve Campaign"}
          className="btn bg-orange form-btn"
          onClick={() => onApprove({campaign_id: campaign_id})}
          disabled={approved} 
        /></td> {/* Rendering the edit link if not approved */}
      </tr>
    </>
  );
}
